import { PAYMENT_SYSTEM, CHECKOUT_PAYMENT_SYSTEM_LIST } from '@/config/paymentSystems';
import { PAYOUT_DESTINATION } from '@/config/payoutDestination';
import { TIPS_TYPE } from '@/config/tipsTypes';

// null - hide
// false - show with default OFF
// true - show with default ON
const INDIVIDUAL_DEFAULTS = {
  [PAYMENT_SYSTEM.RYFT]: {
    gb: false,
    de: false,
    dk: false,
    ch: null,
    ae: null,
    us: false,
    ca: false,
    sa: null,
  },
  [PAYMENT_SYSTEM.PAYER_MAX]: {
    gb: null,
    de: null,
    dk: null,
    ch: null,
    ae: true,
    us: false,
    ca: null,
    sa: false,
  },
  [PAYMENT_SYSTEM.CHECKOUT]: {
    gb: true,
    de: true,
    dk: null,
    ch: false,
    ae: false,
    us: null,
    ca: false,
    sa: null,
  },
};

const MIXED_DEFAULTS = {
  [PAYMENT_SYSTEM.RYFT]: {
    gb: false,
    de: false,
    dk: false,
    ch: null,
    ae: null,
    us: false,
    ca: false,
    sa: null,
  },
  [PAYMENT_SYSTEM.PAYER_MAX]: {
    gb: null,
    de: null,
    dk: null,
    ch: null,
    ae: true,
    us: null,
    ca: null,
    sa: null,
  },
  [PAYMENT_SYSTEM.CHECKOUT]: {
    gb: true,
    de: true,
    dk: null,
    ch: null,
    ae: null,
    us: null,
    ca: null,
    sa: null,
  },
};

function getDefaultsByTipsType({ tipsType, payoutDestination }) {
  if (tipsType === TIPS_TYPE.PERSONAL && payoutDestination === PAYOUT_DESTINATION.INDIVIDUAL) {
    return INDIVIDUAL_DEFAULTS;
  }

  if (tipsType === TIPS_TYPE.MIXED) {
    return MIXED_DEFAULTS;
  }

  return null;
}

export function getInstantPayoutsConfig({
  tipsType,
  payoutDestination,
  paymentSystem,
  country,
  enableNewRyftOnboarding,
}) {
  const gateway = CHECKOUT_PAYMENT_SYSTEM_LIST.includes(paymentSystem)
    ? PAYMENT_SYSTEM.CHECKOUT
    : paymentSystem;

  if (gateway === PAYMENT_SYSTEM.RYFT && !enableNewRyftOnboarding) {
    return null;
  }

  const defaultValue = getDefaultsByTipsType({ tipsType, payoutDestination })?.[gateway]?.[country];

  return typeof defaultValue === 'boolean' ? { defaultValue } : null;
}
